import { render, staticRenderFns } from "./DetailLog.vue?vue&type=template&id=63d7eb9e&"
import script from "./DetailLog.vue?vue&type=script&lang=js&"
export * from "./DetailLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports